import { render, staticRenderFns } from "./CustomRepeat.vue?vue&type=template&id=656e135b&scoped=true"
import script from "./CustomRepeat.vue?vue&type=script&lang=js"
export * from "./CustomRepeat.vue?vue&type=script&lang=js"
import style0 from "./CustomRepeat.vue?vue&type=style&index=0&id=656e135b&prod&lang=scss"
import style1 from "./CustomRepeat.vue?vue&type=style&index=1&id=656e135b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e135b",
  null
  
)

export default component.exports